import MuiCardActionArea, {
  type CardActionAreaProps,
} from "@mui/material/CardActionArea";

export type { CardActionAreaProps };

export function CardActionArea(props: CardActionAreaProps) {
  return <MuiCardActionArea {...props} />;
}
